// extracted by mini-css-extract-plugin
module.exports =  {"table":"X92T9Jt5KBqjeg0es2tX"};